import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import ReactMarkdown from 'react-markdown';
import { useDashboardStore } from '../stores/dashboardStore';
import './Projects.css';

const Projects: React.FC = () => {
    const { config } = useDashboardStore();
    const { projectId } = useParams<{ projectId: string }>();

    // 页面加载时滚动到顶部
    useEffect(() => {
        window.scrollTo(0, 0);
    }, [projectId]);

    // 如果指定了项目ID，显示单个项目详情
    if (projectId) {
        const project = config.projects.find(p => p.id === projectId);
        if (!project) {
            return (
                <div className="projects-page">
                    <div className="container">
                        <div className="not-found">
                            <h1>项目未找到</h1>
                            <p>抱歉，您访问的项目不存在。</p>
                        </div>
                    </div>
                </div>
            );
        }

        return (
            <div className="project-detail-page">
                <div className="container">
                    <div className="project-header">
                        <h1>{project.title}</h1>
                    </div>

                    <div className="project-content">
                        <div className="project-image">
                            <img src={project.image} alt={project.title} />
                        </div>

                        <div className="project-info">
                            <div className="info-section">
                                <h3>项目概述</h3>
                                <p>{project.description}</p>
                            </div>

                            <div className="info-section">
                                <h3>主要功能</h3>
                                <ul className="features-list">
                                    {project.features.map((feature, index) => (
                                        <li key={index}>{feature}</li>
                                    ))}
                                </ul>
                            </div>

                            <div className="project-links">
                                {project.githubUrl && (
                                    <a
                                        href={project.githubUrl}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                        className="btn btn-secondary"
                                    >
                                        查看源码
                                    </a>
                                )}
                            </div>
                        </div>
                    </div>

                    <div className="project-implementation-section">
                        <div className="info-section">
                            <h3>实现路径</h3>
                            <div className="implementation-path-box">
                                <ReactMarkdown>{project.implementationPath}</ReactMarkdown>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    // 显示所有项目列表
    return (
        <div className="projects-page">
            <div className="container">
                <div className="page-header">
                    <h1>个人项目</h1>
                    <p>以下项目展示了我的技术能力和产品思维，每个项目都体现了与产品经理角色的高度匹配。</p>
                </div>

                <div className="projects-grid">
                    {config.projects.map((project) => (
                        <div key={project.id} className="project-card">
                            <div className="project-image">
                                <img src={project.image} alt={project.title} />
                            </div>

                            <div className="project-content">
                                <h3>{project.title}</h3>
                                <p>{project.description}</p>

                                <div className="project-features">
                                    <h4>主要功能：</h4>
                                    <ul>
                                        {project.features.slice(0, 3).map((feature, index) => (
                                            <li key={index}>{feature}</li>
                                        ))}
                                        {project.features.length > 3 && (
                                            <li>...</li>
                                        )}
                                    </ul>
                                </div>

                                <div className="project-implementation-path">
                                    <h4>实现路径：</h4>
                                    <ReactMarkdown>{project.implementationPath}</ReactMarkdown>
                                </div>

                                <div className="project-actions">
                                    <Link
                                        to={`/projects/${project.id}`}
                                        className="btn btn-primary"
                                    >
                                        查看详情
                                    </Link>
                                    {project.demoUrl && (
                                        <a
                                            href={project.demoUrl}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className="btn btn-secondary"
                                        >
                                            查看源码
                                        </a>
                                    )}
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Projects;

